import { useSelector } from 'react-redux';

const useShowHideAns = () => {
	const { shouldShowAns } = useSelector((state) => state.practiceSet);
	return shouldShowAns;
};

export default useShowHideAns;
